module.exports = __webpack_public_path__ + "img/tick.svg?77adc8a1dd944787b0d5db1f64db0389";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demo/tick.svg
// module id = 308
// module chunks = 0